import Sidebar from "../../slices/user-login/Sidebar";


const loginReducer = {
    sidebar: Sidebar,
}

export default loginReducer;